import { appData } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-shrink-0">
            <div className="relative w-[220px] h-[400px] md:w-[260px] md:h-[460px]">
              <div className="absolute inset-0 bg-gradient-to-br from-primary-200/30 to-accent-200/30 rounded-3xl"></div>
              <img
                src={appData.image}
                alt="今日吃瓜手机端展示"
                className="relative w-full h-full object-cover rounded-3xl"
              />
            </div>
          </div>

          <div className="flex-1 w-full">
            <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-3">
              移动入口
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
              {appData.title}
            </h2>
            <p className="text-sm text-foreground-500 mb-4">{appData.subtitle}</p>
            <p className="text-sm text-foreground-700 leading-relaxed mb-6">
              {appData.description}
            </p>

            <ul className="space-y-2 mb-6">
              {appData.features.map((feat) => (
                <li key={feat} className="flex items-center gap-2 text-sm text-foreground-700">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-checkbox-circle-fill text-primary-500 text-sm"></i>
                  </div>
                  {feat}
                </li>
              ))}
            </ul>

            <button className="px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium rounded-md transition-colors duration-200 whitespace-nowrap cursor-pointer">
              {appData.cta}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}